import { createContext } from 'react'

/**
 * @type {import('react').Context<ReturnType<import('./store').WebSocketStore>>}
 */

export const WebsocketContext = createContext()
